<template>
  <div>
    <div class="right-box">
      <div class="wechart-box">
        <p class="title">关于作者</p>
        <ul class="author-info">
          <li v-for="(item, i) in authorList" :key="i">
            <div class="pic" @click="author(item)">
              <img :src="item.avatar" alt />
            </div>
            <div class="author-introduce">
              <div class="name" @click="author(item)">{{ item.name }}</div>
              <div class="other-introduce">
                <span>{{ item.articles_count }}篇文章</span>
                <span>{{ item.followers_count }}人关注</span>
              </div>
            </div>
            <el-button
              :class="item.follow == 'undefined' ? '' : 'isActice'"
              v-if="item.follow"
              @click="cancelAttention(item, i)"
              >已关注</el-button
            >
            <el-button
              :class="item.follow == 'undefined' ? 'isActice' : ''"
              v-else
              @click="attention(item, i)"
              >关注</el-button
            >
          </li>
        </ul>
      </div>
    </div>
    <!-- 弹框 -->
    <LoginDialog
      :loginDialogs="loginDialogs"
      @child-event="getParentEvent"
    ></LoginDialog>
  </div>
</template>
<script>
import {
  getAuthorList,
  getCancelAttention,
  getAttention,
  getFreeArticleDetail
} from "@/api/public";
import LoginDialog from "@/components/loginDialog";
export default {
  components: {
    LoginDialog
  },
  props: {
    isLoginDialogs: [String, Boolean, Number],
    audio_serie_id: [String, Boolean, Number],
    artAuthorList: [Array]
  },
  data() {
    return {
      audio_id: 0,
      authorList: [],
      params: {
        page: 1,
        per: 3
      },
      isShow: -1,
      loginDialogs: false
    };
  },
  watch: {
    artAuthorList(newValue, oldValue) {
      this.authorList = newValue;
    },
    isLoginDialogs(newValue, oldValue) {
      if (newValue > 0) {
        this.loginDialogs = true;
      }
    },
    audio_serie_id(newValue, oldValue) {
      this.audio_id = newValue;
      this.getAuthor();
    }
  },
  methods: {
    getAuthor() {
      getFreeArticleDetail(this.audio_id).then(res => {
        this.authorList = res.data.data.authors;
      });
    },
    author(scope) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "author_detail",
        params: { id: scope.id }
      });
    },
    // 取消关注
    cancelAttention(item, i) {
      if (localStorage.getItem("Authorization")) {
        this.$delete(item, "follow");
        getCancelAttention(item.id).then(res => {});
      } else {
        this.loginDialogs = true;
      }
    },
    attention(item, i) {
      if (localStorage.getItem("Authorization")) {
        this.$set(item, "follow", true);
        getAttention(item.id).then(res => {});
      } else {
        this.loginDialogs = true;
      }
    },
    getParentEvent(data) {
      this.loginDialogs = data;
    }
  },
  created() {},
  mounted() {
    var _this = this;
    setTimeout(function() {
      getAuthorList(_this.params).then(res => {
        if (_this.authorList.length == 0) {
          _this.authorList = res.data.data;
        }
      });
    }, 800);
  }
};
</script>

<style lang="scss" scoped>
.right-box {
  background: #fff;
  text-align: center;
  font-size: 16px;
  margin-bottom: 30px;
  .wechart-box {
    padding: 30px;
    p {
      line-height: 24px;
    }
    .title {
      font-weight: 600;
    }
    div {
      max-width: 200px;
      padding: 20px 30px 10px 30px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .arctileNum {
      font-size: 12px;
      color: #999999;
      span {
        margin-left: 10px;
      }
    }
    .author-info {
      margin-top: 20px;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        position: relative;
        div {
          padding: 0;
        }
        .pic {
          width: 60px;
          height: auto;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        .author-introduce {
          text-align: left;
          font-size: 16px;
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          line-height: 24px;
          width: 44%;
          .other-introduce {
            font-size: 12px;
            color: #999999;
          }
          .name {
            cursor: pointer;
          }
        }
        .el-button {
          background: #0091ff;
          color: #fff;
          width: 70px;
          height: 30px;
          border-radius: 15px;
          text-align: center;
          vertical-align: middle;
          line-height: 7px;
          font-size: 14px;
          padding: 0;
          position: absolute;
          right: 0;
          border: none;
        }

        .isActice {
          background: #fff;
          color: #0091ff;
          border: 1px solid;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutAuthor.vue